import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Avatar } from 'material-ui';

export class Image extends Component {
  static propTypes = {
    style: PropTypes.any,
    src: PropTypes.string,
    size: PropTypes.number,
  };

  render() {
    return (
      <Avatar
        style={this.props.style || null}
        src={this.props.src}
        size={this.props.size || 40}
      />
    );
  }
}
